// extracted by mini-css-extract-plugin
export default {"spinnerWrap":"Spin_spinnerWrap__XWfh7","spinner":"Spin_spinner__GNi3-","loadingCircle":"Spin_loadingCircle__Va2j2"};